import ApiService from '../api.services';

const ParameterService = {
    get: async function () {
        try {
            const response = await ApiService.get(`/api/parameters`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    save: async function (form) {
        const data = {
            parameter: form
        }
        try {
            const response = await ApiService.post('/api/parameters', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default ParameterService;

export { ParameterService };

